// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var greenPointsRouter = {
  path: '/greenPoints',
  component: Layout,
  redirect: '/greenPoints/set',
  name: 'GreenPoints',
  meta: {
    title: '绿色积分',
    icon: 'clipboard'
  },
  children: [{
    path: 'set',
    component: function component() {
      return import('@/views/greenPoints/set');
    },
    name: 'set',
    meta: {
      title: '基础设置'
    }
  }, {
    path: 'receipt',
    component: function component() {
      return import('@/views/greenPoints/receipt');
    },
    name: 'greenPointsReceipt',
    meta: {
      title: '老系统收货确认'
    }
  }, {
    path: 'member',
    component: function component() {
      return import('@/views/greenPoints/member');
    },
    name: 'memer',
    meta: {
      title: '绿色积分会员列表'
    }
  }, {
    path: 'store',
    component: function component() {
      return import('@/views/greenPoints/store');
    },
    name: 'store',
    meta: {
      title: '绿色积分商家列表'
    }
  }, {
    path: 'merchantLevel',
    component: function component() {
      return import('@/views/greenPoints/merchantLevel');
    },
    name: 'merchantLevel',
    meta: {
      title: '绿色积分商家等级'
    }
  }, {
    path: 'Income',
    component: function component() {
      return import('@/views/greenPoints/Income');
    },
    name: 'Income',
    meta: {
      title: '绿色积分收益明细'
    }
  }, {
    path: 'period',
    component: function component() {
      return import('@/views/greenPoints/period');
    },
    name: 'period',
    meta: {
      title: '绿色积分周期记录'
    }
  }, {
    path: 'dividend',
    component: function component() {
      return import('@/views/greenPoints/dividend');
    },
    name: 'dividend',
    meta: {
      title: '绿色积分分红池'
    }
  }, {
    path: 'count',
    component: function component() {
      return import('@/views/greenPoints/count');
    },
    name: 'count',
    meta: {
      title: '绿色积分数据统计'
    }
  }, {
    path: 'reissue',
    component: function component() {
      return import('@/views/greenPoints/reissue');
    },
    name: 'reissue',
    meta: {
      title: '积分补发'
    }
  }, {
    path: 'performance',
    component: function component() {
      return import('@/views/greenPoints/performance');
    },
    name: 'performance',
    meta: {
      title: '团队业绩'
    }
  }, {
    path: 'consumeRecord',
    component: function component() {
      return import('@/views/greenPoints/consumeRecord');
    },
    name: 'consumeRecord',
    meta: {
      title: '消费券使用记录'
    }
  }]
};
export default greenPointsRouter;